import React, { FC } from 'react';
import { ReactComponent as GuideSvg } from '@app/assets/menu/guide.svg';
import { ReactComponent as PermissionSvg } from '@app/assets/menu/permission.svg';
import { ReactComponent as DashboardSvg } from '@app/assets/menu/dashboard.svg';
import { ReactComponent as AccountSvg } from '@app/assets/menu/account.svg';
import { ReactComponent as DocumentationSvg } from '@app/assets/menu/documentation.svg';
import { ReactComponent as FanOffSvg } from '@app/assets/menu/fanoff.svg';
import { ReactComponent as FanOnOneSvg } from '@app/assets/menu/fanonone.svg';
import { ReactComponent as FanOnTwoSvg } from '@app/assets/menu/fanontwo.svg';
import { ReactComponent as FanOnThreeOffSvg } from '@app/assets/menu/fanonthree.svg';
import { ReactComponent as MotionOnSvg } from '@app/assets/menu/motion_on.svg';
import { ReactComponent as MotionOffSvg } from '@app/assets/menu/motion_off.svg';
import { ReactComponent as AvailableSvg } from '@app/assets/menu/available.svg';
import { ReactComponent as BusySvg } from '@app/assets/menu/busy.svg';
import { ReactComponent as ConnectionOnSvg } from '@app/assets/menu/connectionon.svg';
import { ReactComponent as ConnectionOffSvg } from '@app/assets/menu/connectionoff.svg';
import { CUSTOM_ICONS } from '@app/types/common';

interface Props {
  type: string;
}

export const CustomIcon: FC<Props> = props => {
  const { type } = props;
  let com = <GuideSvg />;
  if (type === CUSTOM_ICONS.GUIDE) {
    com = <GuideSvg />;
  } else if (type === CUSTOM_ICONS.PERMISSION) {
    com = <PermissionSvg />;
  } else if (type === CUSTOM_ICONS.DASHBOARD) {
    com = <DashboardSvg />;
  } else if (type === CUSTOM_ICONS.ACCOUNT) {
    com = <AccountSvg />;
  } else if (type === CUSTOM_ICONS.DOCUMENTATION) {
    com = <DocumentationSvg />;
  } else if (type === CUSTOM_ICONS.FAN_OFF) {
    com = <FanOffSvg />;
  } else if (type === CUSTOM_ICONS.FAN_ON_ONE) {
    com = <FanOnOneSvg />;
  } else if (type === CUSTOM_ICONS.FAN_ON_TWO) {
    com = <FanOnTwoSvg />;
  } else if (type === CUSTOM_ICONS.FAN_ON_THREE) {
    com = <FanOnThreeOffSvg />;
  } else if (type === CUSTOM_ICONS.MOTION_ON) {
    com = <MotionOnSvg />;
  } else if (type === CUSTOM_ICONS.MOTION_OFF) {
    com = <MotionOffSvg />;
  } else if (type === CUSTOM_ICONS.AVAILABLE) {
    com = <AvailableSvg />;
  } else if (type === CUSTOM_ICONS.BUSY) {
    com = <BusySvg />;
  } else if (type === CUSTOM_ICONS.CONNECTION_ON) {
    com = <ConnectionOnSvg />;
  } else if (type === CUSTOM_ICONS.CONNECTION_OFF) {
    com = <ConnectionOffSvg />;
  } else {
    com = <GuideSvg />;
  }
  return <span className="anticon">{com}</span>;
};
